import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent {
  @Input() description = ''
  @Input() previousVisible = true
  @Input() previousLabel = 'Wróć'
  @Input() nextLabel = 'Dalej'
  @Input() nextVisible = true
  @Input() previousEnabled = true
  @Input() nextEnabled = true
  @Output() previousStepClicked = new EventEmitter()
  @Output() nextStepClicked = new EventEmitter()
  constructor() { }

  goToPreviousStep(): void {
    this.previousStepClicked.emit()
  }

  goToNextStep(): void {
    this.nextStepClicked.emit()
  }

}
